import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import Amplify from 'aws-amplify';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import awsconfig from './aws-config';
import { store, persistor } from './store';
import App from './App';
import { Loader } from './components';
import { initSentry } from './utils/sentry';
// Side-effect: instala filtros de console.error/warn pra suprimir
// warnings conhecidos de libs upstream (recharts 1.x bug). Importar
// cedo (antes do primeiro render) garante que o filtro pegue todos
// os warnings — incluindo os do mount inicial.
import './utils/console-filters';

// Sentry tem que ser inicializado ANTES de qualquer codigo que possa
// lancar — caso contrario erros do bootstrap nao chegam no dashboard.
// initSentry vira no-op se REACT_APP_SENTRY_DSN nao estiver setado.
initSentry();

Amplify.configure(awsconfig);

export const history = createBrowserHistory();

ReactDOM.render(
  <Provider store={store}>
    {/* PersistGate atrasa o render do App ate o redux-persist rehydratar
        do localStorage. Sem isso, na primeira render o store estaria com
        valores INITIAL_STATE e os efeitos de fetch dispariam baseados em
        dados ausentes, anulando o ganho de refresh. */}
    <PersistGate loading={<Loader />} persistor={persistor}>
      <Router>
        <App />
      </Router>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);
